import moment from "moment";

export class WagePolicyService {
    constructor($http, $q, apexApiUrl) {
        'ngInject';
        this.$http = $http;
        this.$q = $q;
        this.apexApiUrl = apexApiUrl;
    }

    retrieveWagePolicies() {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "wage-policies",
            headers: {
                Accept: "application/json"
            }
        })
            .then(function (response) {
                return response.data;
            });
    }

    retrieveWagePolicy(wagePolicyID) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "wage-policies/" + wagePolicyID,
            headers: {
                Accept: "application/json"
            }
        })
            .then(function (response) {
                return response.data;
            });
    }

    saveWagePolicy(wagePolicy) {
        if (wagePolicy.IsNew) {
            return this._createWagePolicy(wagePolicy);
        } else {
            return this._updateWagePolicy(wagePolicy.WagePolicyID, wagePolicy);
        }
    }

    deleteWagePolicy(wagePolicyID) {
        throw new Error("Deleting a wage policy is not allowed.");
    }

    _createWagePolicy(wagePolicy) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "wage-policies",
            data: JSON.stringify(wagePolicy),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        })
            .then(function (response) {
                return response.data;
            });
    }

    _updateWagePolicy(wagePolicyID, wagePolicy) {
        return this.$http({
            method: "PUT",
            url: this.apexApiUrl + "wage-policies/" + wagePolicyID,
            data: JSON.stringify(wagePolicy),
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(() => this.retrieveWagePolicy(wagePolicyID));
    }

    retrieveTodayWagePolicies() {
        return this.retrieveWagePolicies()
            .then(wagePolicies => {
                return wagePolicies.map(wagePolicy => {
                    const currentPolicy = wagePolicy.History.reduce((currentPolicy, archive) => {
                        const isCurrent = (!archive.StartDate || moment().isSameOrAfter(archive.StartDate))
                            && (!archive.EndDate || moment().isSameOrBefore(archive.EndDate));
                        if (isCurrent) {
                            return archive;
                        }
                        if (!currentPolicy || !currentPolicy.StartDate
                            || archive.StartDate && moment(currentPolicy.StartDate).isBefore(archive.StartDate)) {
                            // Use the iterated policy if the current one isn't the earliest policy or earlier
                            // than the iterated policy.
                            return archive;
                        }
                        return currentPolicy;
                    }, null);
                    if (currentPolicy) {
                        // Use the wage that is active for today. Otherwise, use the current wage defined for the policy.
                        wagePolicy.MinimumWage = currentPolicy.MinimumWage;
                    }
                    return wagePolicy;
                });
            });
    }
}
